"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const GraphandFieldJSON_1 = __importDefault(require("./fields/GraphandFieldJSON"));
const GraphandFieldRelation_1 = __importDefault(require("./fields/GraphandFieldRelation"));
const GraphandModel_1 = __importDefault(require("./GraphandModel"));
class GraphandWebhookLogsModel extends GraphandModel_1.default {
    static get baseFields() {
        return {
            webhook: new GraphandFieldRelation_1.default({
                ref: "Webhook",
                multiple: false,
            }),
            request: new GraphandFieldJSON_1.default(),
            response: new GraphandFieldJSON_1.default(),
        };
    }
}
exports.default = GraphandWebhookLogsModel;
